<template>
  <div class="mt-2">
    <p class="text-xs md:text-sm">
      Copyright © {{ year }} The National Insurance Board of The Bahamas.
    </p>
  </div>
</template>

<script setup lang="ts">
import dayjs from "/@/plugins/dayjs";
const year = dayjs().year();
</script>
